import finalConfig from "../../config/index.js";
$(async () => {
  if (page === "weChat") {
    require("./weChat.js");
  }
});

$(() => {
  //设置内容屏幕高度
  const $bodyBlock = $(".bodyBlock");
  const $win = $(window);
  const setbodyBlockHeight = () => {
    let height = $win.height();
    $bodyBlock.css({
      "min-height": height,
    });
  };
  $bodyBlock.on("load", setbodyBlockHeight);
  setbodyBlockHeight();
});

$(() => {
  $("#scanQrCode").on("click", function (event) {
    wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
      success: function (res) {
        const result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
        const code = result.split("/").pop() || "";
        if (result.indexOf("51cjm.cn") !== -1) {
          $.toResultByCode(code, 1);
        } else if (result.indexOf("cjm.so") !== -1) {
          location.href = `http://wap.cjm.so/Operator/Common/AntiFakeQueryResult.aspx?code=${code}`;
        } else {
          layer.open({
            content: "此码为假码，请联系厂家！",
            skin: "msg",
            time: 2,
          });
        }
      },
    });
  });
});
